import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useLabelTranslations = () => {
  const { formatMessage } = useIntl();

  const labelTranslations = useMemo(() => {
    return {
      labelName: formatMessage(messages.labelName),
      labelPrice: formatMessage(messages.labelPrice),
      labelStat: formatMessage(messages.labelStat),
      labelAppliesTo: formatMessage(messages.labelAppliesTo),
      labelMarketingText: formatMessage(messages.labelMarketingText),
      marketingPlaceholder: formatMessage(messages.marketingPlaceholder),
      labelContactingPatientRequired: formatMessage(
        messages.labelContactingPatientRequired,
      ),
      labelIsPerStudyPricing: formatMessage(messages.labelIsPerStudyPricing),
      labelVisibility: formatMessage(messages.labelVisibility),
      labelVisibilityPublic: formatMessage(messages.labelVisibilityPublic),
      labelVisibilityPrivate: formatMessage(messages.labelVisibilityPrivate),
      labelAllowMultiplePurchases: formatMessage(
        messages.labelAllowMultiplePurchases,
      ),
    };
  }, [formatMessage]);

  return labelTranslations;
};

export default useLabelTranslations;
